/**
 * article模块接口列表
 */

import qs from 'qs'; // 根据需求是否导入qs模块
import base from '../base'; // 导入接口域名列表
import axios from '../request'; // 导入http中创建的axios实例

const strageList = {
  // 获取交易策略
   getStrageData(data){
    return axios.post(`${base.sq}/api/answer/ansPolicy/queryPolicyListWithUser`, qs.stringify(data))
   },
   //根据 id 来查策略
   getStrageDataById(data){
      return axios.post(`${base.sq}/api/answer/queryAnsPolicyWithUser`, qs.stringify(data))
   },
  // 获取话题列表
   getTopicData(data){
    return axios.post(`${base.sq}/api/answer/ansTopic/queryTodayAnsTopicAnswerListApi`, qs.stringify(data))
   },
   // 点赞添加
   addLike(data){
      return axios.post(`${base.sq}/api/answer/ansPolicy/addAnsPolicyViews`, qs.stringify(data))
   },
    //获取首页数据
   getIndexData(data){
       return axios.post(`${base.sq}/api/answer/ansTopic/queryAnsHomeVo`, qs.stringify(data))
   },
   //获取我的问题
   getMyQuestion(data){
      return axios.post(`${base.sq}/api/answer/ansQuestion/queryMyQuestionVo`, qs.stringify(data))
   },
   //获取产品数据
   getProductData(){
      // return axios.get(`${base.qs}/public/marketprice/cf`)
      return axios.get(`${base.info}/v1/api/marketPrice/list`)
   },
   //获取产品数据
   getProductDataSingle(data){
      // return axios.get(`${base.qs}/public/marketprice/cfBySymbol?symbol=${data}`)
      return axios.get(`${base.info}/v1/api/marketPrice/list?productCodes=${data}`)
   },
   //获取话题详情
   getTopicDetail(data){
      return axios.post(`${base.sq}/api/answer/ansTopic/queryAnsTopicVoInfo`,qs.stringify(data) )
   },
   //登录
   login(data){
      return axios.post(`${base.qs}/public/cfd/login`,qs.stringify(data) )
   },
   //登录 获取
   loginInfo(data){
      return axios.post(`${base.sq}/api/user/info/login`,qs.stringify(data) )
   },
   //发布
   publish(data){
      return axios.post(`${base.sq}/api/answer/ansQuestion/addAnsQuestion`,qs.stringify(data) )
   },
   //视频分页接口
   getVideoData(data){
      return axios.post(`${base.sq}/api/answer/ansVideo/queryAnsVideoListPageApi`,qs.stringify(data) )
   },
   //增加视频播放次数
   addTimes(data){
      return axios.post(`${base.sq}/api/answer/ansVideo/addAnsVideoViews`,qs.stringify(data) )
   },
   //分析师对应的交易策略
   analystStrageData(data){
      return axios.post(`${base.sq}/api/answer/ansPolicy/queryAnsPolicyListPageApi`,qs.stringify(data) )
   },
   //更新昵称
   updataNickName(data){
      return axios.post(`${base.sq}/api/user/info/updateUserInfo`,qs.stringify(data) )
   },
   //点赞
   questionLikes(data){
      return axios.post(`${base.sq}/api/answer/ansQuestion/likes`,qs.stringify(data) )
   },
   //详情选择看涨
   addAddNums(data){
      return axios.post(`${base.sq}/api/answer/ansTopic/addAddNums`,qs.stringify(data) )
   },
   //详情选择看跌
   addSubNums(data){
      return axios.post(`${base.sq}/api/answer/ansTopic/addSubNums`,qs.stringify(data) )
   },
   //获取昵称
   getNickName(data){
      return axios.post(`${base.sq}/api/user/info/getUserById`,qs.stringify(data) )
   },
   addView(data){
      return axios.post(`${base.sq}/api/answer/ansTopic/addViewNums`,qs.stringify(data) )
   },
   //自动登录
   autoLogin(data){
      //以下headers寫法2023/5/23和後端Ryan確認 (原寫法API在UAT環境下異常, 在PRD正常)
      const headers = {
         Origin: `${base.origin}`
       };

      return axios.post(`${base.qs}/public/cfd/loginForLiveApp`,qs.stringify(data), { headers })
   }


};

export default strageList;
